import { onToggleFolderPane } from 'owa-mail-ribbon-command-actions/lib/commandActions';
import { ExtraTopRibbonControlsBeforeTabs } from 'owa-left-pane-layout/lib/components/ExtraTopRibbonControlsBeforeTabs';
import { shouldShowFolderPane } from 'owa-mail-layout/lib/selectors/shouldShowFolderPane';
import { owaComputedFn } from 'owa-computed-fn';
import { type StateChangeSource } from 'owa-left-pane-layout/lib/types/StateChangeSource';
import { FileButton } from 'owa-mail-file-menu';
import { LazyFileMenuContent } from 'owa-mail-file-menu-content';
import { logUsage } from 'owa-analytics';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';
import type { JSX } from 'react';

const onToggleFolderPaneWrapper = () => {
    onToggleFolderPane(0, undefined /*newState, will toggle if not passed through*/);
};
const fileMenuContent = <LazyFileMenuContent />;

const mailFileButtonTelemetry = () => {
    logUsage('MainRibbon_FileButton_Click', getModuleContextMailboxInfo());
};

export const getExtraTopRibbonControlsBeforeTabs: () => JSX.Element = owaComputedFn(
    function getExtraTopRibbonControlsBeforeTabsMail() {
        return (
            <>
                {!isWin32StylingEnabled() && (
                    <ExtraTopRibbonControlsBeforeTabs
                        onClick={onToggleFolderPaneWrapper}
                        isExpanded={shouldShowFolderPane()}
                    />
                )}
                <FileButton menuContent={fileMenuContent} onClick={mailFileButtonTelemetry} />
            </>
        );
    }
);
